import React, { useEffect, useState, Fragment } from 'react';
import { AlarmClockIcon, FlameIcon, UsersIcon } from 'lucide-react';
import { useSharedCountdown } from './CountdownTimer';
export function UrgencyModule() {
  const secondsLeft = useSharedCountdown();
  const TOTAL_SPOTS = 50;
  const [spotsLeft, setSpotsLeft] = useState(23);
  useEffect(() => {
    const spotsTimer = setInterval(() => {
      setSpotsLeft(prev => {
        if (prev <= 4) return prev;
        return Math.random() < 0.25 ? prev - 1 : prev;
      });
    }, 12000);
    return () => clearInterval(spotsTimer);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const hours = 0;
  const percentLeft = spotsLeft / TOTAL_SPOTS * 100;
  return <section className="w-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-red-900 via-red-950 to-black py-12 px-4 border-y-4 border-red-600 relative overflow-hidden shadow-[0_0_40px_rgba(220,38,38,0.2)]" data-id="element-537">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-red-600/10 rounded-full blur-3xl pointer-events-none" data-id="element-538"></div>
      <div className="max-w-4xl mx-auto" data-id="element-539">
        {/* Top alert badge */}
        <div className="flex justify-center mb-5" data-id="element-540">
          <div className="inline-flex items-center gap-2 bg-red-600 text-white font-black text-xs md:text-sm px-4 py-2 rounded-full uppercase tracking-wider shadow-lg shadow-red-900/50 ring-2 ring-red-400/40" data-id="element-541">
            <FlameIcon className="h-4 w-4 animate-pulse" data-id="element-542" />
            ¡Atención! Oferta a punto de finalizar
          </div>
        </div>

        {/* Main headline */}
        <h2 className="text-3xl md:text-5xl font-black text-center mb-3 uppercase leading-tight" data-id="element-543">
          <span className="text-white" data-id="element-544">Aprovechá el</span>{' '}
          <span className="text-red-400 drop-shadow-[0_0_14px_rgba(239,68,68,0.7)]" data-id="element-545">
            60% OFF
          </span>
          <br data-id="element-546" />
          <span className="text-white text-2xl md:text-3xl font-bold" data-id="element-547">
            antes de que termine
          </span>
        </h2>

        <p className="text-center text-red-100/80 text-sm md:text-base mb-8" data-id="element-548">
          Esta promoción es exclusiva y limitada. Cuando el reloj llegue a cero
          o se agoten los cupos, vuelve al precio regular.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-2" data-id="element-549">
          {/* Countdown Card */}
          <div className="bg-gradient-to-br from-red-950 to-black rounded-2xl p-6 border-2 border-red-500/60 shadow-2xl shadow-red-900/40" data-id="element-550">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-551">
              <AlarmClockIcon className="h-5 w-5 text-red-400" data-id="element-552" />
              <p className="text-red-400 font-bold text-sm uppercase tracking-widest" data-id="element-553">
                La oferta expira en
              </p>
            </div>
            <div className="flex justify-center gap-2 md:gap-3" data-id="element-554">
              {[{
              value: hours,
              label: 'Horas'
            }, {
              value: minutes,
              label: 'Minutos'
            }, {
              value: seconds,
              label: 'Segundos'
            }].map((unit, i) => <Fragment key={unit.label} data-id="element-555">
                  <div className="flex flex-col items-center" data-id="element-556">
                    <div className="bg-black border-2 border-red-600/70 rounded-lg px-3 md:px-5 py-2 md:py-3 shadow-[0_0_15px_rgba(239,68,68,0.3)] min-w-[60px] md:min-w-[80px]" data-id="element-557">
                      <span className="text-3xl md:text-5xl font-black text-red-400 tabular-nums tracking-tight drop-shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-558">
                        {String(unit.value).padStart(2, '0')}
                      </span>
                    </div>
                    <span className="text-[10px] md:text-xs text-red-200/70 mt-2 uppercase tracking-wider font-semibold" data-id="element-559">
                      {unit.label}
                    </span>
                  </div>
                  {i < 2 && <span className="text-3xl md:text-5xl font-black text-red-500 self-start mt-1 md:mt-2" data-id="element-560">
                      :
                    </span>}
                </Fragment>)}
            </div>
          </div>

          {/* Spots Card */}
          <div className="bg-gradient-to-br from-red-950 to-black rounded-2xl p-6 border-2 border-red-500/60 shadow-2xl shadow-red-900/40" data-id="element-561">
            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-562">
              <UsersIcon className="h-5 w-5 text-red-400" data-id="element-563" />
              <p className="text-red-400 font-bold text-sm uppercase tracking-widest" data-id="element-564">
                Cupos disponibles
              </p>
            </div>
            <div className="text-center mb-3" data-id="element-565">
              <span className="text-5xl md:text-6xl font-black text-white tabular-nums" data-id="element-566">
                {spotsLeft}
              </span>
              <span className="text-2xl md:text-3xl font-bold text-red-200/50" data-id="element-567">
                {' '}
                / {TOTAL_SPOTS}
              </span>
            </div>
            {/* Progress bar */}
            <div className="relative w-full h-3 bg-red-950 rounded-full overflow-hidden border border-red-700/60" data-id="element-568">
              <div className="absolute inset-y-0 left-0 bg-gradient-to-r from-red-700 via-red-500 to-red-400 rounded-full transition-all duration-1000 ease-out shadow-[0_0_12px_rgba(239,68,68,0.8)]" style={{
              width: `${percentLeft}%`
            }} data-id="element-569" />
            </div>
            <p className="text-center text-xs text-red-200/80 mt-3 font-semibold" data-id="element-570">
              {spotsLeft <= 10 ? <span className="text-red-300 font-bold uppercase" data-id="element-571">
                  ⚠️ ¡Quedan muy pocos! Asegurá el tuyo ya
                </span> : <>
                  Se están agotando rápido —{' '}
                  <span className="text-red-300 font-bold" data-id="element-572">
                    {TOTAL_SPOTS - spotsLeft} ya tomados
                  </span>
                </>}
            </p>
          </div>
        </div>

        {/* Bottom warning */}
        <div className="text-center mt-6" data-id="element-573">
          <p className="text-red-100/90 text-sm md:text-base" data-id="element-574">
            🔒 Una vez que el contador llegue a 00:00,{' '}
            <span className="text-red-300 font-bold" data-id="element-575">
              esta oferta desaparece
            </span>{' '}
            y el precio sube a <span className="line-through" data-id="element-576">ARS 84.990</span>
          </p>
        </div>
      </div>
    </section>;
}